import { URLParams } from '../../interfaces/url-params.interface';

export enum URL_PARAM_REFERRAL_TYPE {
  SAVED_QUOTE = "Quote", // When agent saves a quote and shares it
  PERSONAL_PRODUCER_URL = "PURL", // When an agent has a generic, commission-catching referral URL
  REFERRAL = "Referral"
}
export interface GlobalDataStateStructure {
  referralType: URL_PARAM_REFERRAL_TYPE; //consumer side referral type that is loaded on first click by consumer
  urlParams: URLParams;
  //Find Member Prepop Check Params
  findMemberId?: string
}
